/* Tus ultimas vistas.
   Guarda en el navegador del propio visitante los productos que mira y los
   vuelve a mostrar cuando regresa. No manda nada al servidor y no sale de
   su telefono. Las tarjetas se arman con el DOM, no con HTML pegado.

   Este archivo lo cargan dos sitios: el registrador del pie (que graba en
   las paginas de producto) y la seccion que muestra la lista. El candado de
   abajo hace que la segunda carga no vuelva a correr nada. */
(function () {
  'use strict';
  if (window.__hrVistos) return;
  window.__hrVistos = 1;

  var LLAVE = 'hr_vistos';
  var TOPE = 20;

  function leer() {
    try { return JSON.parse(localStorage.getItem(LLAVE)) || []; } catch (e) { return []; }
  }

  function guardar(p) {
    if (!p || !p.h) return;
    try {
      var l = leer().filter(function (x) { return x.h !== p.h; });
      l.unshift(p);
      localStorage.setItem(LLAVE, JSON.stringify(l.slice(0, TOPE)));
    } catch (e) {}
  }

  function el(tag, cls, txt) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (txt != null) n.textContent = txt;
    return n;
  }

  function tarjeta(p, c) {
    var a = el('a', 'tp');
    a.href = p.u;

    var foto = el('div', 'tp__foto');
    if (p.i) {
      var img = el('img', 'tp__img');
      img.src = p.i;
      img.alt = p.t || '';
      img.loading = 'lazy';
      img.decoding = 'async';
      foto.appendChild(img);
    }
    if (c.off && p.o) foto.appendChild(el('span', 'tp__off', '-' + p.o + '%'));
    a.appendChild(foto);

    var cuerpo = el('div', 'tp__cuerpo');
    if (c.estrellas) {
      var st = el('span', 'tp__stars', '★★★★★');
      st.setAttribute('aria-hidden', 'true');
      cuerpo.appendChild(st);
    }
    cuerpo.appendChild(el('h3', 'tp__tit', p.t || ''));

    var pre = el('div', 'tp__precio');
    pre.appendChild(el('span', 'tp__ahora', p.p || ''));
    if (c.antes && p.c) pre.appendChild(el('s', 'tp__antes', p.c));
    cuerpo.appendChild(pre);

    if (c.boton) cuerpo.appendChild(el('span', 'tp__btn', c.textoBoton || 'VER'));
    a.appendChild(cuerpo);
    return a;
  }

  function pintar(cont) {
    var pista = cont.querySelector('[data-vistos-pista]');
    if (!pista) return;

    var actual = cont.getAttribute('data-actual') || '';
    var max = parseInt(cont.getAttribute('data-max'), 10) || 8;
    var c = {
      off: cont.getAttribute('data-off') === '1',
      antes: cont.getAttribute('data-antes') === '1',
      estrellas: cont.getAttribute('data-estrellas') === '1',
      boton: cont.getAttribute('data-boton') === '1',
      textoBoton: cont.getAttribute('data-texto-boton') || 'VER'
    };

    var lista = leer().filter(function (x) { return x.h !== actual; }).slice(0, max);
    if (lista.length < 1) { cont.remove(); return; }

    lista.forEach(function (p) { pista.appendChild(tarjeta(p, c)); });

    var puntos = cont.querySelector('[data-puntos]');
    if (puntos) {
      lista.forEach(function (p, i) {
        var b = el('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Producto ' + (i + 1));
        puntos.appendChild(b);
      });
    }
    if (lista.length < 2) {
      var nav = cont.querySelector('.pr__nav');
      if (nav) nav.remove();
    }

    cont.hidden = false;
    document.dispatchEvent(new CustomEvent('shopify:section:load'));
  }

  function iniciar() {
    var dato = document.querySelector('[data-visto-actual]');
    if (dato) {
      try { guardar(JSON.parse(dato.textContent)); } catch (e) {}
    }
    document.querySelectorAll('[data-vistos]').forEach(pintar);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
